export enum NavigationMenuName {
  LEFT = 'left',
  HOME = 'home',
  FOOTER = 'footer'
}
